var map = {
	"./M_CH.svg": 4843,
	"./M_DI.svg": 9336,
	"./M_IM.svg": 1140,
	"./M_MO.svg": 7474,
	"./M_PR.svg": 5036,
	"./M_TE.svg": 7871,
	"./M_TI.svg": 6459
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9686;